import React, { FunctionComponent } from "react";
import Button from "react-bootstrap/Button";
import Icon from "../../../../components/Icon";

interface IYaraStringMatchPagingProps {
  currentResult?: number;
  totalResults?: number;
  onChangeCurrentResult: (toIndex: number) => void;
}

const YaraStringMatchPaging: FunctionComponent<IYaraStringMatchPagingProps> = ({
  currentResult = 0,
  totalResults = 1,
  onChangeCurrentResult
}) => (
  <div className="d-flex align-items-center gap-10">
    <Button
      onClick={() =>
        onChangeCurrentResult(
          currentResult === 0 ? totalResults - 1 : currentResult - 1
        )
      }
      variant="prompt-secondary"
      style={{ width: 36, height: 36, minWidth: "unset" }}
      className="btn--icon-only"
      data-testid="yara_string_paging_back"
    >
      <Icon name={"chevron-left"} className="dropdown-toggle__chevron-icon" />
    </Button>

    <span>
      Result: <span className="fw-bold">{currentResult + 1}</span> of{" "}
      {totalResults || "-"}
    </span>

    <Button
      onClick={() => onChangeCurrentResult((currentResult + 1) % totalResults)}
      variant="prompt-secondary"
      style={{ width: 36, height: 36, minWidth: "unset" }}
      className="btn--icon-only"
      data-testid="yara_string_paging_forward"
    >
      <Icon name={"chevron-right"} className="dropdown-toggle__chevron-icon" />
    </Button>
  </div>
);

export default YaraStringMatchPaging;
